<template>
  <div class="add-wi-step" @click="$emit('click')">
    <div class="btn-center-content">
      <b-icon icon="subdirectory-arrow-right" size="fa-2x"> </b-icon>
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddWorkInstructionStepButton',
  props: {
    label: {
      type: String,
      default: 'Create new Work Instruction Step',
    },
  },
};
</script>

<style lang="scss" scoped>
.add-wi-step {
  margin-left: 30px;
  border-bottom-style: dashed;
  border-left-style: dashed;
  border-right-style: dashed;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-color: grey;
  padding: 5px;
  border-width: 2px;
}

.btn-center-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-right: 25px;
  cursor: pointer;
}
</style>
